import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AddEditPackageModel, PackageVersionBOM, PackageVersionList } from 'projects/Administration/src/app/business-entities/add-edit-package-model';
import { LaborDetailsViewModel } from 'projects/Administration/src/app/business-entities/labor-details-view-model';
import { BillOfMaterialType } from 'projects/Administration/src/app/business-entities/package-BOM-Item';
import { PartsListViewModel } from 'projects/Administration/src/app/business-entities/parts-list-view-model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { BrandType } from 'projects/Administration/src/app/business-entities/vehicle-list-view-model';
import { BrandService } from 'projects/Administration/src/app/business-services/brand.service';
import { LaborService } from 'projects/Administration/src/app/business-services/labor.service';
import { PackageService } from 'projects/Administration/src/app/business-services/package.service';
import { PartsBusinessService } from 'projects/Administration/src/app/business-services/parts.service';
import { ServicesService } from 'projects/Administration/src/app/business-services/services.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import { SearchLaborComponent } from '../../labor/search-labor/search-labor.component';
import { SearchPartsComponent } from '../../parts/search-parts/search-parts.component';
import { SearchServiceComponent } from '../../services/search-service/search-service.component';
import { ApplicationSourceService } from '../../../business-services/application-source.service';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { isDeepStrictEqual } from 'util';

@Component({
  selector: 'app-add-package',
  templateUrl: './add-package.component.html',
  styleUrls: ['./add-package.component.css']
})
export class AddPackageComponent implements OnInit {



  constructor(
    private applicationSourceService: ApplicationSourceService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private brandService: BrandService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private service: PackageService,
    private currentLanguageService: CurrentLanguage,
    private userService: UserDataService,
    private activeModal: NgbActiveModal,
    private serviceServices: ServicesService,
    private partService: PartsBusinessService,
    private laborService: LaborService,
    private cdr: ChangeDetectorRef,
    private secureStorage: SecureStorage,
    public cultureLocaleService: CultureLocaleService,
    public dealerBusinessService: DealerBusinessService,
  ) { }


  openPanels: Array<string> = ['first', 'Second'];
  Language: any[];
  IsReceptionUser: boolean = false;
  popupCloseResult = false;
  addEditPackageForm: FormGroup = new FormGroup({});
  isFormValid: boolean = false;
  makeList: BrandType[] = [];
  makeName: string;
  billOfMaterialType: BillOfMaterialType[];
  packageVersionList: any;
  selectedPartList: PartsListViewModel[] = [];
  selectedLaborList: LaborDetailsViewModel[] = [];
  isBOMItemValidationError: boolean = false;
  isAddForm: boolean = true;
  features: Features[] = [];
  isDmsSyncPackage: boolean = false;
  isShowAddBOMSection: boolean = false;
  subscription : Subscription;
  dealerList: SelectListItemViewModel[];
  dropdownSettings = {};
  selectedDealer:any[]=[];
  selectedDealerId: string;
  isDealerSpecific: boolean = true;
  isShowDealerDropdown:boolean = false;
  dealerResult: any[];


  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 6,
      allowSearchFilter: false,
      maxHeight: 500
    };
    this.Language = this.currentLanguageService.LanguageList;
    this.applicationSourceService.getFeatures();
    this.addEditPackageForm = this.formBuilder.group({
      id: [0],
      makeCode: [null, [Validators.required]],
      packageNumber: ['', [Validators.required]],
      packageName: new FormArray([]),
      versionNumber: [0, [Validators.required]],
      versionName: new FormArray([]),
      packageBOMItem: new FormArray([]),
      isActive: [true]
    })
    this.AddBOMItem();
    this.IsReceptionUser = this.userService.currentUserValue.roleType === Enums.UserRoles.Reception;
    this.isShowDealerDropdown = localStorage.getItem("Theme") === 'mg';
    if(this.isShowDealerDropdown){
      if(this.userService.currentUserValue.roleType === Enums.UserRoles.SuperAdmin 
        || this.userService.currentUserValue.roleType === Enums.UserRoles.SuperUser){
            this.isDealerSpecific = false;
        }
        this.getUserDealers();
    }
    this.getFeatures();
    this.getLanguage();
    this.getAllData();
    //For Add condition
    this.isShowAddBOMSection = true;
    this.isAddForm = true;

     //For Edit condition
     if (this.service.packageId > 0) {
      this.isAddForm = false;
      this.isShowAddBOMSection = false;
      this.getPackageDetail()
      this.addEditPackageForm.get('packageNumber').disable();
      }
  }
  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if(features == null || features == undefined){
      this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
        features = res;
        if (features?.length > 0) {
          this.isDmsSyncPackage = features.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
        }
      })
    }else{
      this.isDmsSyncPackage = features.find(x => x.featureCode === Enums.FeatureCode.DmsPackageSync)?.isActive;
    }
  }

  onDropdownDealerSelected(dealerId: any): void {
    if (dealerId == null) {
      this.selectedDealer = [];
      this.selectedDealerId='';
    } else {
      if (dealerId.length == 0) {
        this.selectedDealer= [];
        this.selectedDealerId=''
      }
      else
      {
        let dealerIdValue='';
        dealerId.forEach(element => {
            dealerIdValue +=element.value + ','
        });
        this.selectedDealerId=dealerIdValue;
      }
    }
  }
  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerResult = response.userDealersModel;
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealerBusinessService.dealerList = this.dealerList;
      if(this.dealerList.length===1)
      {
        this.selectedDealerId = response.userDealersModel[0].dealerId;
      }
    })
  }

  mapdealer(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName
        single.dealerDmsNo = element.dealerDmsNo

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  getAllData() {
    this.GetAllMake();
    this.GetBillOfMaterialType();
  }


  async GetAllMake(): Promise<void> {
    this.makeList = await this.brandService.GetBrandDropdownResult();
  }

 
  async getPackageDetail() {
    this.spinner.show();
    await this.service.GetPackageDetails(this.service.packageId).then(response => {
      this.spinner.hide();
      let data = response.responseObject;
      this.mapPackageDetail(data)
     
    });
    this.addEditPackageForm.get('packageBOMItem').disable();
    this.addEditPackageForm.get('versionName').disable();
  }

  mapPackageDetail(packageDetailModel) {
    this.addEditPackageForm.patchValue({
      id: packageDetailModel.packageDetail.id,
      makeCode: packageDetailModel.packageDetail.makeCode,
      packageNumber: packageDetailModel.packageDetail.packageNumber,
      isActive: packageDetailModel.packageDetail.isActive,
      packageName: packageDetailModel.packageLanguageDetail
    });
    this.packageVersionList = packageDetailModel.packageDetail.packageVersionDetailList;
    this.selectedDealer = [];
    let dealerIdValue='';
    if(packageDetailModel.packageDealerAssociationDetails.length > 0){

      if(this.dealerList && packageDetailModel.packageDealerAssociationDetails)
      {
          this.dealerList.forEach(x=>{
            packageDetailModel.packageDealerAssociationDetails.forEach(y=>{
          if(x.value===y.dealerId){
            this.selectedDealer.push(x);
          }
        })
        })
      }

      packageDetailModel.packageDealerAssociationDetails.forEach(element => {
        dealerIdValue +=element.dealerId + ','
      });
      this.selectedDealerId=dealerIdValue;
    }
  }

  get t() { return this.cpf.packageName as FormArray; }

  get v() { return this.cpf.versionName as FormArray; }

  get packageBOM() { return this.cpf.packageBOMItem as FormArray; }

  get cpf() {
    return this.addEditPackageForm.controls;
  }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: [0, Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }

    if (this.v.length < number) {
      for (let i = this.v.length; i < number; i++) {
        this.v.push(this.formBuilder.group({
          languageId: [0, Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.v.removeAt(i);
      }
    }
  }

  isPrice(event): void {
    const isDigit = Utility.isDigit(event);
    const isDecimalPoint = Utility.isDecimalPoint(event);
    if (!isDecimalPoint && !isDigit) {
      event.preventDefault();
    }
  }

  async GetBillOfMaterialType() {
    await this.service.GetBillOfMaterialType().then((response) => {
      this.spinner.hide();
      if (response?.responseObject?.errorCount === 1) {
        this.spinner.hide();
        let errorMsg = this.translate.instant("lblRecordNotFound");
        this.toastr.error(errorMsg)
      }
      else if ( response?.responseObject?.length != 0) {
        this.billOfMaterialType = response.responseObject;
      }
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });
  }
 
  showCommonError(message){
    this.toastr.error(message);
    this.isBOMItemValidationError = true
  
  }
  AddBOMItem(item?: any) {
    if (item) {
      let ErrorMessage = this.translate.instant("lblPleaseProvideMandatoryValue");
      if (!item.controls.typeId.value) {
        this.showCommonError(ErrorMessage)
        return;
      }

      //line selected
      if ((item.controls.typeId.value === Constant.BOMTypeText) && !item.controls.description.value) {
        //add line value
        this.showCommonError(ErrorMessage);
        return;
      }
      //type part,labour & service selected
      else if ((item.controls.typeId.value !== Constant.BOMTypeText) && (!item.controls.number.value || !item.controls.description.value
        && !item.controls.costType.value || !item.controls.duration.value)) {
          this.showCommonError(ErrorMessage);
        return
      }
      //type part,labour & service selected and number is not selected from search popup
      else if ( (item.controls.typeId.value !== Constant.BOMTypeText) && (item.controls.isNumberSelected.value===false)) {
        let SelectValueErrorMessage=this.translate.instant("lblPleaseSelectValueFromSearchPopup");
        this.toastr.error(SelectValueErrorMessage);
        this.isBOMItemValidationError = true
        return
      }

    }
    this.isBOMItemValidationError = false;
    this.packageBOM.push(
      this.formBuilder.group({
        typeId: [null, Validators.required],
        number: ['', Validators.required],
        isNumberSelected:[false],
        description: ['', Validators.required],
        costType: [{ value: '', disabled: true }, Validators.required],
        duration: [0, Validators.required],
        unitofMeasureCode: [{ value: '', disabled: true }, Validators.required],
        price: [{ value: 0, disabled: true }],
        //serviceId of selected service when type service
        serviceId: [{ value: 0, disabled: true }],
        salesPriceAmount: [{ value: 0, disabled: true }]
      })
    );

  }

  removeBOMItem(index: number) {
    if (this.packageBOM.length > 0)
      this.packageBOM.removeAt(index);
  }

  onBOMTypeSelect(event: any, index: number, item: any) {
    if (event) {
      item.controls["costType"].setValue(this.billOfMaterialType.filter(x => x.typeId === this.packageBOM.value[index].typeId)[0].costType);
      item.controls["unitofMeasureCode"].setValue(this.billOfMaterialType.filter(x => x.typeId === this.packageBOM.value[index].typeId)[0].unitofMeasureCode);
      this.enableDisableBOMFormControl(item, this.packageBOM.value[index].typeId);
    }
    this.cdr.detectChanges();
  }

  enableDisableBOMFormControl(item: any, typeId: number, isAfterSelectingNumber: boolean = false) {
    if (typeId === Constant.BOMTypeText) {
      item.controls.number.disable();
      item.controls.duration.disable();
      item.controls.price.disable();
    }
    else {
      item.controls.number.enable();
      item.controls.description.enable();
      item.controls.duration.enable();
    }
    if (isAfterSelectingNumber) {
      item.controls.typeId.disable();
      item.controls.number.disable();
    }
  }

  openPopUp(index: number, item: any) {
    switch (this.packageBOM.value[index].typeId) {
      case Constant.BOMTypeService:
        this.handleServiceSelection(item);
        break;
      case Constant.BOMTypePart:
        this. handlePartSelection(item);
        break;
      case Constant.BOMTypeLabor:
       this.handleLabourSelection(item)
        break;
      case Constant.BOMTypeText:

        break;
    }
    this.cdr.detectChanges();
  }
  handleServiceSelection(item){
    this.serviceServices.SelectedServices = [];
        this.serviceServices.registrationDate = '';
        this.serviceServices.engineTypeCode = '';
        this.serviceServices.vehicleTypeCode = '';
        this.serviceServices.companyMakeCode = '';
        this.serviceServices.previousKilometer = '';
        this.serviceServices.dealerId = '';
        this.serviceServices.searchService = item.value.number;

        const serviceModalRef = this.modalService.open(SearchServiceComponent, {
          windowClass: 'pop-wid1366',
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
        serviceModalRef.result.then((_result) => { 
          // This is intentional
        }, (_reason) => {

          if(_reason)
          {
            item.controls["isNumberSelected"].setValue(true);
            item.controls["number"].setValue(this.serviceServices.SelectedServices[0].serviceNo);
            item.controls["description"].setValue(this.serviceServices.SelectedServices[0].name);
            item.controls["duration"].setValue(this.serviceServices.SelectedServices[0].duration);
            item.controls["price"].setValue(this.serviceServices.SelectedServices[0].unitPrice !== undefined ? this.serviceServices.SelectedServices[0].unitPrice : this.serviceServices.SelectedServices[0].price);
            item.controls["salesPriceAmount"].setValue(((item.controls["price"].value/60) * (item.controls["duration"].value * 60)).toFixed(2));
            item.controls["serviceId"].setValue(this.serviceServices.SelectedServices[0].serviceId);
            item.controls.typeId.disable();
            item.controls.number.disable();

            //if multiple item
            if (this.serviceServices.SelectedServices.length > 1) {
              this.serviceServices.SelectedServices.forEach((element, index) => {
                if (index > 0) {
                  this.AddBOMItem();
                  let i = (this.packageBOM.controls.length) - 1;
                  let billOfMatrial = this.billOfMaterialType.filter(x => x.typeId === Constant.BOMTypeService)[0];
                  this.packageBOM.controls[i].patchValue({
                    isNumberSelected:true,
                    typeId: billOfMatrial.typeId,
                    costType: billOfMatrial.costType,
                    unitofMeasureCode: billOfMatrial.unitofMeasureCode,
                    number: element.serviceNo,
                    description: element.name,
                    price: element.unitPrice !== undefined ? element.unitPrice : element.price,
                    duration: element.duration,
                    serviceId: element.serviceId
                  });
                  this.enableDisableBOMFormControl(this.packageBOM.controls[i], billOfMatrial.typeId, true);
                }
              });
            }
          }
          serviceModalRef.dismiss(true);
          this.spinner.hide();
        })
  }

  handlePartSelection(item){
    this.selectedPartList = [];
        
        if(this.isShowDealerDropdown){
          if ( this.selectedDealer.length <= 0) {
            let errorMessage = this.translate.instant("lblPleaseProvideMandatoryValue");
            this.toastr.error(errorMessage);
            return
          }
          if(this.selectedDealer.length == 1){
            this.partService.locationCode = this.dealerResult.find(f=>f.dealerId == this.selectedDealer[0].value).dealerDmsNo;
          }else{
            this.partService.locationCode =  Enums.MgDealerNo.oslo;
          }
        }else{
          this.partService.locationCode = '';
        }
        this.partService.searchPartNumber = item.value.number;
        const partModalRef = this.modalService.open(SearchPartsComponent, {
          windowClass: 'pop-wid1366 pop-hig500',
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        });
        partModalRef.result.then((_result) => { 
          // This is intentional
        }, (reason) => {
          this.popupCloseResult = this.getDismissReason(reason);
          if (this.popupCloseResult) {
            this.selectedPartList = this.partService.selectedPartListWithAddtionalItems;
            if(this.selectedPartList.length>0)
            {
              item.controls["isNumberSelected"].setValue(true);
              item.controls["number"].setValue(this.selectedPartList[0].partNumber);
              item.controls["description"].setValue(this.selectedPartList[0].description);
              item.controls["duration"].setValue(this.selectedPartList[0].qty);
              item.controls["price"].setValue(this.selectedPartList[0].unitPrice);
              item.controls["salesPriceAmount"].setValue((this.selectedPartList[0].unitPrice * this.selectedPartList[0].qty).toFixed(2));
              item.controls.typeId.disable();
              item.controls.number.disable();
              //if multiple item
              if (this.selectedPartList.length > 1) {
                this.selectedPartList.forEach((element, index) => {
                  if (index > 0) {
                    this.AddBOMItem();
                    let i = (this.packageBOM.controls.length) - 1;
                    let billOfMatrial = this.billOfMaterialType.filter(x => x.typeId === Constant.BOMTypePart)[0];
                    this.packageBOM.controls[i].patchValue({
                      isNumberSelected:true,
                      typeId: billOfMatrial.typeId,
                      costType: billOfMatrial.costType,
                      unitofMeasureCode: billOfMatrial.unitofMeasureCode,
                      number: element.partNumber,
                      description: element.description,
                      price: element.unitPrice,
                      duration: element.qty
                    });
                    this.enableDisableBOMFormControl(this.packageBOM.controls[i], billOfMatrial.typeId, true);
                  }
                });
              }
            }       
            partModalRef.dismiss(true);
            this.spinner.hide();
          }
        })
  }
  handleLabourSelection(item){
    let dealerId= "";
    if(this.selectedDealer.length == 1){
      this.selectedDealer.forEach(element => {
        dealerId +=element.value
      });
    }

    this.selectedLaborList = [];
    this.laborService.searchLabourNumber = item.value.number;
    this.laborService.dealerId = dealerId;
    const labourModalRef = this.modalService.open(SearchLaborComponent, {
      windowClass: 'pop-wid1366 pop-hig500',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    labourModalRef.componentInstance.companyMakeCode = this.empty(this.addEditPackageForm.controls['makeCode'].value) ? "" : this.addEditPackageForm.controls['makeCode'].value;
    labourModalRef.result.then((_result) => { 
      // This is intentional
    }, (_reason) => {
      if(_reason)
      {
        this.handleSelectedLabour(item);
      }
      labourModalRef.dismiss(true);
      this.cdr.detectChanges();
      this.spinner.hide();

    })
  }
  handleSelectedLabour(item){
    
    this.selectedLaborList = this.laborService.selectedLaborList;
    if (this.selectedLaborList) {
      item.controls["isNumberSelected"].setValue(true);
      item.controls["number"].setValue(this.selectedLaborList[0].laborNo);
      item.controls["description"].setValue(this.selectedLaborList[0].name);
      item.controls["duration"].setValue(this.selectedLaborList[0].duration);
      item.controls["price"].setValue(this.selectedLaborList[0].fixedPrice);
      item.controls["salesPriceAmount"].setValue(((item.controls["price"].value/60) * (item.controls["duration"].value * 60)).toFixed(2));
      item.controls.typeId.disable();
      item.controls.number.disable();
      if (this.selectedLaborList.length > 1) {
        this.selectedLaborList.forEach((element, index) => {
          if (index > 0) {
            this.AddBOMItem();
            let i = (this.packageBOM.controls.length) - 1;
            let billOfMatrial = this.billOfMaterialType.filter(x => x.typeId === Constant.BOMTypeLabor)[0];
            this.packageBOM.controls[i].patchValue({
              isNumberSelected:true,
              typeId: billOfMatrial.typeId,
              costType: billOfMatrial.costType,
              unitofMeasureCode: billOfMatrial.unitofMeasureCode,
              number: element.laborNo,
              description: element.name,
              price: element.fixedPrice,
              duration: element.duration
            });

            this.enableDisableBOMFormControl(this.packageBOM.controls[i], billOfMatrial.typeId, true);
          }
        });
      }
    }
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  isQtyPrice(event, item) {
    if (!this.cultureLocaleService.isQtyPrice(event, item.controls["duration"].value)) {
      let msg = this.translate.instant("lblValidValue");
      this.toastr.error(msg)
      event.preventDefault();
    }
  }

  onFormSubmit() {

    let successMessage = this.translate.instant("lblPackageAddedSuccessfully");
    let errorMessage = this.translate.instant("lblPleaseProvideMandatoryValue");

    if (this.addEditPackageForm.invalid) {
      this.toastr.error(errorMessage);
      return
    }
    if (this.isShowDealerDropdown && this.selectedDealer.length <= 0) {
      this.toastr.error(errorMessage);
      return
    }

    const model = this.mapPackageModel();

    this.spinner.show();
    this.service.AddUpdatePackage(model).then(res => {

      if (res.responseCode === Constant.SuccessResponseCode) {
        if (res.responseObject.isSuccess) {
          this.ngOnDestroy();
          this.activeModal.close({ success: true });
          this.spinner.hide();
          this.toastr.success(successMessage);
        } else {
          if (res.responseObject.retValue == '-8000') {
            this.spinner.hide();
            let errormsg = this.translate.instant("lblPackageNumberAlreadyExists");
            this.toastr.warning(errormsg);
          } else {
            this.spinner.hide();
            let errormsg = this.translate.instant("lblInternalError");
            this.toastr.error(errormsg);
          }
        }
      }
      else if (res.responseCode === Constant.InternalError) {
        this.spinner.hide();
        let errormsg = this.translate.instant("lblInternalError");
        this.toastr.error(errormsg);
      }
      else if (res.responseCode === Constant.ResponseCode) {
        this.spinner.hide();
        let errormsg = this.translate.instant("lblAlreadyAddedService");
        this.toastr.warning(errormsg);
      }
      this.spinner.hide();
    }, _error => {
      this.spinner.hide();
    });

  }

  mapPackageModel() {
    let dealerId='';
    if(this.selectedDealer.length > 0){
      this.selectedDealer.forEach(element => {
        dealerId +=element.value + ','
      });
      this.selectedDealerId=dealerId.replace(/,\s*$/, "")
    }
    let isSyncToDms = this.isDmsSyncPackage;
    //below condition only for BNH
    if(localStorage.getItem("Theme") === 'bnh' && this.isDmsSyncPackage && this.addEditPackageForm.controls['id'].value > 0 && this.service.sourceTypeId == Enums.SourceId.DMS){
      isSyncToDms = true;
    }else if(localStorage.getItem("Theme") === 'bnh' && this.isDmsSyncPackage && this.addEditPackageForm.controls['id'].value > 0 && this.service.sourceTypeId == Enums.SourceId.Planner){
      isSyncToDms = false;
    }else if(localStorage.getItem("Theme") === 'bnh' && this.isDmsSyncPackage && this.addEditPackageForm.controls['id'].value == 0){
      isSyncToDms = false;
    }
    
    let addEditPackage: AddEditPackageModel =
    {
      id: this.addEditPackageForm.controls['id'].value,
      isDmsSyncPackage: isSyncToDms,
      packageNo: this.empty(this.addEditPackageForm.controls['packageNumber'].value) ? "" : this.addEditPackageForm.controls['packageNumber'].value,
      makeCode: this.empty(this.addEditPackageForm.controls['makeCode'].value) ? "" : this.addEditPackageForm.controls['makeCode'].value,
      sourceTypeId: this.addEditPackageForm.controls['id'].value > 0 ? this.service.sourceTypeId : Constant.PlannerSource,
      isActive: this.addEditPackageForm.get('isActive').value,
      packageLnlnvalue: this.addEditPackageForm.controls['packageName'].value,
      addUpdatePackageVersions: this.mapPackageVersionAndBOMItem(),
      isDealerSpecific : this.isDealerSpecific,
      dealerId : this.selectedDealerId
    }
    //if edit form and new version not added than allow to edit only package name and make vesrion detail form empty
    if(!this.isShowAddBOMSection && !this.isAddForm)
    {
      addEditPackage.addUpdatePackageVersions=[];
    }
    return addEditPackage;
  }

  mapPackageVersionAndBOMItem() {
    const addUpdatePackageVersions: Array<PackageVersionList> = [];
    const packageVersion = this.createPackageVersion();
    const packageVersionBOM = this.createPackageVersionBOM();
  
    packageVersion.addUpdatePackageBOMDetails = packageVersionBOM;
    addUpdatePackageVersions.push(packageVersion);
    return addUpdatePackageVersions;
  }
  createPackageVersion() {
    const packageVersion: PackageVersionList = {
      id: 0,
      packageId: this.addEditPackageForm.controls['id'].value,
      packageNo: this.empty(this.addEditPackageForm.controls['packageNumber'].value) ? "" : this.addEditPackageForm.controls['packageNumber'].value,
      packageVersionNo: this.addEditPackageForm.controls['versionNumber'].value,
      makeCode: this.empty(this.addEditPackageForm.controls['makeCode'].value) ? "" : this.addEditPackageForm.controls['makeCode'].value,
      packageVersionLnValues: this.addEditPackageForm.controls['versionName'].value,
      addUpdatePackageBOMDetails: []
    };
    return packageVersion;
  }
  createPackageVersionBOM(){
    const packageVersionBOM: Array<PackageVersionBOM> = [];
    for (let i = 0; i < this.packageBOM.length; i++) {
      const packageBOMControl = this.packageBOM.controls[i];
      const addEditPackageFormControls = this.addEditPackageForm.controls;

      const versionBOM =this.createVirsionBOM(addEditPackageFormControls, packageBOMControl)

      packageVersionBOM.push(versionBOM);
  }

  return packageVersionBOM;
  }
  createVirsionBOM(addEditPackageFormControls, packageBOMControl){
    return {
      id: 0,
      packageId: addEditPackageFormControls['id'].value,
      packageVersionId: 0,
      packageNo: this.empty(addEditPackageFormControls['packageNumber'].value) ? "" : addEditPackageFormControls['packageNumber'].value,
      packageVersionNo: this.empty(addEditPackageFormControls['versionNumber'].value) ? 0 : parseInt(addEditPackageFormControls['versionNumber'].value),
      makeCode: this.empty(addEditPackageFormControls['makeCode'].value) ? "" : addEditPackageFormControls['makeCode'].value,
      lineNo: 0,
      bomTypeId: this.empty(packageBOMControl.get('typeId').value) ? 0 : parseInt(packageBOMControl.get('typeId').value),
      costType: this.empty(packageBOMControl.get('costType').value) ? "" : packageBOMControl.get('costType').value,
      no: this.empty(packageBOMControl.get('number').value) ? "" : packageBOMControl.get('number').value,
      description: packageBOMControl.get('description').value,
      quantity: this.empty(packageBOMControl.get('duration').value) ? 0 : +packageBOMControl.get('duration').value,
      unitofMeasureCode: this.empty(packageBOMControl.get('unitofMeasureCode').value) ? "" : packageBOMControl.get('unitofMeasureCode').value,
      price: this.empty(packageBOMControl.get('price').value) ? 0 : +packageBOMControl.get('price').value,
      salesPriceAmount: this.empty(packageBOMControl.get('salesPriceAmount').value) ? 0 : +packageBOMControl.get('salesPriceAmount').value,
      serviceId: this.empty(packageBOMControl.get('serviceId').value) ? 0 : parseInt(packageBOMControl.get('serviceId').value),
  };
  }
  ngOnDestroy(): void {
    this.service.packageNumber = null;
    this.laborService.searchLabourNumber = null;
    this.serviceServices.searchService = null;
    this.partService.searchPartNumber = null;
    if(this.subscription){
      this.subscription.unsubscribe();
    }
  }
  OnClose() {
    this.activeModal.close({success:false})
  }

  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }

  copyToNewVersion(versionDetail) {
    //enable this form control as we will add new verion name & new BOM item
    this.addEditPackageForm.get('packageBOMItem').enable();
    this.addEditPackageForm.get('versionName').enable();
    this.isShowAddBOMSection = true;
    const BOMDetailList = this.copyToBOMDetails(versionDetail.packageBOMDetailList);
    //Add BOM item to formArray
    if (BOMDetailList.length > 0) {
      this.packageBOM.clear();
      //add no of bom item
      BOMDetailList.forEach((_element) => {
        this.AddBOMItem();
      });
      //patch value
      this.addEditPackageForm.patchValue({
        packageBOMItem: BOMDetailList,
      });
      this.packageBOM.controls.forEach(element => {
        this.enableDisableBOMFormControl(element, element.get('typeId').value, true);
      });
    }

  }

  copyToBOMDetails(BOMList: any) {
    let supperArray = [];
    if (BOMList && BOMList.length > 0) {

      BOMList.forEach(element=>{ 

        let single = Object();
        single.typeId = element.bomTypeId;
        single.number = element.no;
        single.description = element.description;
        single.costType = element.costType;
        single.duration = element.quantity;
        single.unitofMeasureCode = element.unitofMeasureCode;
        single.price = element.unitPrice;
        single.serviceId = element.serviceId;
        single.salesPriceAmount = element.salesPriceAmount;
        single.isNumberSelected=true;
      supperArray.push(single);
      })
    }
    return supperArray;
  }

  deletePackageVersion(packageId:number,packageVersionId:number)
  {
    this.spinner.show();
    this.service.DeletePackageVersion(packageId,packageVersionId).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        if(response.responseObject === Constant.PackageVersionDeleted)
        {
          let deletedmsg = this.translate.instant("lblPackageVersionDeleted");
          this.toastr.success(deletedmsg);
          this.ngOnInit();
        }
        else if(response.responseObject === Constant.PackageRequireAtleastOneVersion)
        {
          let deletedmsg = this.translate.instant("lblAtleastOnePackageVersionRequire");
          this.toastr.error(deletedmsg);
        }
        else if(response.responseObject === Constant.PackageVersionAssociatedWithAppointment)
        {
          let deletedmsg = this.translate.instant("lblAppointmentAssociatedwiththisPackageVersion");
          this.toastr.error(deletedmsg);
        }
        this.spinner.hide();

      }
    });
  }

  onBlur(_event,_i,item){
    if(item.controls.typeId.value !== Constant.BOMTypePart){
      item.controls["salesPriceAmount"].setValue((item.controls["price"].value * item.controls["duration"].value).toFixed(2));
    }else{
      item.controls["salesPriceAmount"].setValue(((item.controls["price"].value/60) * (item.controls["duration"].value * 60)).toFixed(2));
    }
  }

}
